import React, { useState, useEffect } from 'react';
import UDIRowPopup, { UDIPopupField, UDIAddRowButton, useUDIRowPopup } from './UDIRowPopup.js';

const MarketInfo = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.MemberStatesWhereDeviceIsOrIsToBeMadeAvailable",
    fieldTitle = "Member States where device is or is to be made available on the market",
    forceIsEditing = null
}) => {
    // Country Dictionary
    const countries = [
        { key: "general.country-iso-at", value: "Austria" },
        { key: "general.country-iso-be", value: "Belgium" },
        { key: "general.country-iso-bg", value: "Bulgaria" },
        { key: "general.country-iso-cy", value: "Cyprus" },
        { key: "general.country-iso-cz", value: "Czechia" },
        { key: "general.country-iso-de", value: "Germany" },
        { key: "general.country-iso-dk", value: "Denmark" },
        { key: "general.country-iso-ee", value: "Estonia" },
        { key: "general.country-iso-el", value: "Greece" },
        { key: "general.country-iso-es", value: "Spain" },
        { key: "general.country-iso-fi", value: "Finland" },
        { key: "general.country-iso-fr", value: "France" },
        { key: "general.country-iso-hr", value: "Croatia" },
        { key: "general.country-iso-hu", value: "Hungary" },
        { key: "general.country-iso-ie", value: "Ireland" },
        { key: "general.country-iso-is", value: "Iceland" },
        { key: "general.country-iso-it", value: "Italy" },
        { key: "general.country-iso-li", value: "Liechtenstein" },
        { key: "general.country-iso-lt", value: "Lithuania" },
        { key: "general.country-iso-lu", value: "Luxembourg" },
        { key: "general.country-iso-lv", value: "Latvia" },
        { key: "general.country-iso-mt", value: "Malta" },
        { key: "general.country-iso-nl", value: "Netherlands" },
        { key: "general.country-iso-no", value: "Norway" },
        { key: "general.country-iso-pl", value: "Poland" },
        { key: "general.country-iso-pt", value: "Portugal" },
        { key: "general.country-iso-ro", value: "Romania" },
        { key: "general.country-iso-se", value: "Sweden" },
        { key: "general.country-iso-si", value: "Slovenia" },
        { key: "general.country-iso-sk", value: "Slovakia" },
        { key: "general.country-iso-tr", value: "Turkiye" },
        { key: "general.country-iso-xi", value: "United Kingdom (Northern Ireland)" }
    ];

    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    const initialFormState = {
        Country: { Value: countries[0].key, Text: countries[0].value },
        StartDate: '',
        EndDate: ''
    };

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [formData, setFormData] = useState(initialFormState);
    const [editingIndex, setEditingIndex] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCountryChange = (e) => {
        const value = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        setFormData(prev => ({
            ...prev,
            Country: { Value: value, Text: text }
        }));
    };

    const handleSave = () => {
        const updatedItems = [...items];
        if (editingIndex !== null) {
            updatedItems[editingIndex] = formData;
        } else {
            updatedItems.push(formData);
        }

        setItems(updatedItems);

        // Update Global 
        setUDI(prevItem => ({
            ...prevItem,
            MemberStatesWhereDeviceIsOrIsToBeMadeAvailable: updatedItems
        }));

        popup.close();
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            MemberStatesWhereDeviceIsOrIsToBeMadeAvailable: updatedItems
        }));

        resetForm();
    };

    // Old rows may still hold a full datetime string (pre-fix bulk import) instead of a plain
    // date - normalize to YYYY-MM-DD for both display and the date input, regardless of what's stored.
    const formatDateOnly = (value) => {
        if (!value) return '';
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
        const parsed = new Date(value);
        if (isNaN(parsed.getTime())) return value;
        const yyyy = parsed.getFullYear();
        const mm = String(parsed.getMonth() + 1).padStart(2, '0');
        const dd = String(parsed.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const handleEdit = (index) => {
        setFormData({
            ...items[index],
            StartDate: formatDateOnly(items[index].StartDate),
            EndDate: formatDateOnly(items[index].EndDate),
        });
        setEditingIndex(index);
        popup.openEdit();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setEditingIndex(null);
    };

    const popup = useUDIRowPopup(resetForm);



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    // --- Edit Mode ---
    return (

        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?

                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Country</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={editingIndex === index ? 'udi-complex-field-row-selected' : ''}
                                            >
                                                <td>{item.Country?.Text}</td>
                                                <td>{formatDateOnly(item.StartDate)}</td>
                                                <td>{formatDateOnly(item.EndDate)}</td>
                                                <td>
                                                    <button type="button" className="udiEditButton" onClick={() => handleEdit(index)}>
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    <button type="button" className="udiRemoveButton" onClick={() => handleRemove(index)}>
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <UDIAddRowButton label="Add Market Info" onClick={popup.openAdd} />

                                <UDIRowPopup
                                    isOpen={popup.isOpen}
                                    title={editingIndex !== null ? "Edit Market Info" : "Add Market Info"}
                                    saveLabel={editingIndex !== null ? "Save" : "Add"}
                                    onClose={popup.close}
                                    onSave={handleSave}
                                >
                                    <UDIPopupField label="Country">
                                        <select value={formData.Country.Value} onChange={handleCountryChange}>
                                            {countries.map(c => <option key={c.key} value={c.key}>{c.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                    <UDIPopupField label="Start Date">
                                        <input type="date" name="StartDate" value={formData.StartDate} onChange={handleInputChange} />
                                    </UDIPopupField>
                                    <UDIPopupField label="End Date">
                                        <input type="date" name="EndDate" value={formData.EndDate} onChange={handleInputChange} />
                                    </UDIPopupField>
                                </UDIRowPopup>

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>

                            :


                            <>

                                <table className="dataTable" style={{ borderWidth: '1px', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Country</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.Country?.Text}</td>
                                                <td>{formatDateOnly(item.StartDate)}</td>
                                                <td>{formatDateOnly(item.EndDate)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
						        <input
							        type="button"
							        className="udiActionButton"
							        value="Edit"
							        onClick={() => changeIsEditingField(true)}
						        />
                                */}


                            </>

                        }

                    </div>

                </div>
            </div>
        </div>


    );
};

export default MarketInfo;